import { screenIs } from 'lib-node-question-builder/utils';

/**
 * Formats a name by combining first name, last name, optional middle name, and optional suffix.
 * By default, middle names are abbreviated to their initial followed by a period, but can be included in full if withFullMiddleName is true.
 *
 * @example
 * formatName('John', 'Doe'); // 'John Doe'
 * formatName('John', 'Doe', 'Michael'); // 'John M. Doe'
 * formatName('John', 'Doe', 'Michael', undefined, true); // 'John Michael Doe'
 * formatName('John', 'Doe', undefined, 'Jr.'); // 'John Doe Jr.'
 * formatName('John', 'Doe', 'Michael', 'Jr.'); // 'John M. Doe Jr.'
 */
export const formatName = (
  firstName: string,
  lastName: string,
  middleName?: string,
  suffix?: string,
  withFullMiddleName = false,
) => {
  const shortendMiddleName =
    middleName && !withFullMiddleName ? `${middleName.charAt(0)}.` : '';
  const nameParts = [
    firstName,
    withFullMiddleName ? middleName : shortendMiddleName,
    lastName,
    suffix,
  ].filter(Boolean);
  return nameParts.join(' ');
};

export const READONLY_CONDITION = screenIs('isWriteAccessDisabled', true);
